<template>
  <div class="w-full h-full relative overlay" :style="documentStyle" v-show="isNotHidden">
    <div class="svg-overlay absolute left-0 top-0">
      <svg xmlns="http://www.w3.org/2000/svg"
        :width="svg.w" :height="svg.h" :viewBox="svg.viewBox"
      >
        <g>
          <polygon fill="#000000" opacity=".7" :points="leftPoints" />
          <polygon fill="#000000" opacity=".7" :points="rightPoints" />
        </g>
      </svg>
    </div>
    <vue-draggable-resizable
      ref="draggable"
      v-if="initialized"
      :min-width="minWidth"
      :min-height="minHeight"
      :max-width="maxWidth"
      :max-height="maxHeight"
      :x="x"
      :y="y"
      :w="w"
      :h="h"
      :parent="true"
      :resizable="true"
      :active="active"
      :handles="['tl','tr','br','bl']"
      :key="keyRenderer"
      @resizing="onResize"
      @dragging="onDrag"
      @dragstop="setChange"
      @resizestop="setChange"
    >
      <div class="square--custom cursor-move" :style="boxStyle"></div>
    </vue-draggable-resizable>
  </div>
</template>
<script>
import VueDraggableResizable from 'vue-draggable-resizable'
import { isEmpty, values } from 'lodash'
import { coordinateByRotation, percentToPx, pxToPercent } from '../../../../utils'
import { PERCENT_PADDING } from '../../../../utils/constants'
export default {
  name: 'SignatureCutPdfTool',
  inject: ['modalState', 'setModalStateProperty'],
  components: {
    VueDraggableResizable
  },
  props: {
    document: {
      type: Object,
      default: () => ({})
    },
    preset: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      active: false,
      cache: {},
      initialized: false,
      keyRenderer: 0,
      minWidth: 50,
      minHeight: 50,
      maxWidth: 0,
      maxHeight: 0,
      x: 0,
      y: 0,
      h: 0,
      w: 0,
      img: ''
    }
  },
  computed: {
    documentStyle() {
      const { page: { width, height } } = this.document
      return {
        height: `${height}px`,
        width: `${width}px`
      }
    },
    boxStyle() {
      return {
        width: `${this.w}px`,
        height: `${this.h}px`
      }
    },
    leftPoints() {
      const { maxWidth, maxHeight, x, y, h } = this
      const middleX = Math.round(maxWidth / 2)
      return `0,0 ${middleX},0 ${middleX},${y} ${x},${y} ${x},${h + y} ${middleX},${h + y} ${middleX},${maxHeight} 0,${maxHeight}`
    },
    rightPoints() {
      const { maxWidth, maxHeight, x, y, w, h } = this
      const middleX = Math.round(maxWidth / 2)
      return `${maxWidth},0 ${middleX},0 ${middleX},${y} ${w+x},${y} ${w+x},${h + y} ${middleX},${h + y} ${middleX},${maxHeight} ${maxWidth},${maxHeight}`
    },
    svg() {
      const { maxWidth, maxHeight } = this
      const w = Math.round(maxWidth)
      const h = Math.round(maxHeight)
      return { w, h, viewBox: `0 0 ${w} ${h}` }
    },
    isLoaded() {
      return !isEmpty(this.document) && !isEmpty(this.preset)
    },
    isNotHidden() {
      return this.isLoaded && this.preset.show && !this.preset.applied
    },
  },
  watch: {
    document() {
      this.initTool()
    }
  },
  mounted() {
    if (this.isLoaded) {
      this.initTool()
    }
  },
  methods: {
    initTool() {
      if (this.isLoaded) {
        const { page: { width, height } } = this.document
        this.w = width - percentToPx(width, PERCENT_PADDING)
        this.h = height - percentToPx(height, PERCENT_PADDING)
        this.x = percentToPx(width, PERCENT_PADDING) / 2
        this.y = percentToPx(height, PERCENT_PADDING) / 2
        this.maxWidth = width
        this.maxHeight = height
        this.initialized = true
        this.$nextTick(() => {
          this.forceRerender()
          this.setChange()
        })
      }
    },
    setChange() {
      const { page: { width, height } } = this.document
      const r = this.modalState.config.rotation
      const left = Math.round(pxToPercent(width, this.x))
      const top = Math.round(pxToPercent(height, this.y))
      const right = Math.round(100 - pxToPercent(width, this.w + this.x))
      const bottom = Math.round(100 - pxToPercent(height, this.h + this.y))
      const { coords, points } = coordinateByRotation(r, left, top, right, bottom)
      const newPreset = {
        coordinates: coords,
        points: points
      }
      this.setModalStateProperty({ ...this.preset, ...newPreset }, 'cutPdf', 'preset')
    },
    onDrag(left, top) {
      this.x = left
      this.y = top
    },
    onResize(left, top, width, height) {
      this.x = left
      this.y = top
      this.w = width
      this.h = height
    },
    forceRerender() {
      this.keyRenderer += 1
    }
  }
}
</script>
<style scoped lang="scss">
@import "~vue-draggable-resizable/src/components/vue-draggable-resizable.css";
.square--custom {
  background-color: transparent;
}
::v-deep {
  .vdr {
    border: none!important;
  }
  .handle {
    background: #898DFF!important;
    border: solid 1px #898DFF!important;
  }
  .handle-tl {
    top: -5px!important;
    left: -5px!important;
  }
  .handle-tr {
    top: -5px!important;
    right: -5px!important;
  }
  .handle-br {
    bottom: -5px!important;
    right: -5px!important;
  }
  .handle-bl {
    bottom: -5px!important;
    left: -5px!important;
  }
}
</style>
